import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
// import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { ImagePreview } from "../../posts/Photos/PhotoUploader";
import { do_nothing_function, useXS } from 'common-frontend-components';
import { postCardMobileStyle, postCardStyle } from "../../../../assets/styles/styles";
// import {textColor} from "../../../../assets/styles/colors";
import { galleryPhotosStore } from "../../../../stores/galleries/galleryPhotosStore";
import { galleryIconsStore } from "../../../../stores/galleries/galleryIconsStore";
import { galleriesFullViewStore } from "../../../../stores/galleries/galleriesFullViewStore";
export const WwwGalleryTabIcon = ({ gallery, width = 200 }) => {
    const photos = galleryPhotosStore.usePhotosByGalleryId(gallery.id);
    return (_jsx(ImagePreview, { style: { width: `${width}px`, height: 'auto' }, photos: photos || [], index: 0, icons: photos, onClick: do_nothing_function }, void 0));
};
export const WwwGalleryCard = ({ gallery, width = 300 }) => {
    const photos = galleryPhotosStore.usePhotosByGalleryId(gallery.id);
    const icons = galleryIconsStore.useIconsByGalleryId(gallery.id);
    const isMobile = useXS();
    const onClick = (e) => {
        e.stopPropagation();
        galleriesFullViewStore.openFullView({ photos: photos || [], index: 0 });
    };
    return (_jsx(Box, { sx: { width, cursor: 'pointer' }, onClick: onClick, children: _jsx(Card, { variant: "outlined", sx: { ...(isMobile ? postCardMobileStyle : postCardStyle), background: 'transparent', boxShadow: 'none', padding: 0 }, children: _jsx(Grid, { container: true, spacing: 1, children: icons &&
                    _jsx(Grid, { item: true, onClick: onClick, children: _jsx(WwwGalleryTabIcon, { gallery: gallery }, void 0) }, void 0) }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=WwwGalleryCard.js.map